import { candidateReducer } from './reducer';
import { initialCandidateState } from './state';

const CANDIDATE_MODULE_NAME = 'candidate';

export { CANDIDATE_MODULE_NAME, initialCandidateState, candidateReducer };
